export default "__VITE_ASSET__d387edd3__"